export default __webpack_public_path__ + "static/media/map.84315616.png";